// extracted by mini-css-extract-plugin
export default {"root":"UserCameraControls_root__LGZ3B","button":"UserCameraControls_button__gnhYE"};